import { forwardRef, useImperativeHandle, useState } from "react";
import { Modal } from "react-bootstrap";
import { formatDataHora } from "../../../../../commons/utils";
import { model_cliente_observacao } from "../../../../../models";
import { ConsultaPadrao } from "../../../../../components/ConsultaPadrao";

export const ObservacaoCliente = forwardRef((props: any, ref: any) => {
    const [show, setShow] = useState(false);
    const [model, setModel] = useState<any>();

    const columns = [
        { field: 'prospobscadastro', header: 'Cadastro', body: (e: any) => formatDataHora(e.prospobscadastro) },
        { field: 'prospobscomentario', header: 'Observação' },
        { field: 'functions', style: { minWidth: '7rem', width: '7rem' } }
    ];

    function closeModal() {
        setShow(false);
    }

    function openModal(_empdid: any, _prospid: any) {
        let _model = { ...model_cliente_observacao };

        _model.api_get = _model.api_get + '?prospid=' + _prospid + '&empid=' + _empdid;
        _model.base = {
            ..._model.base,
            prospect: {
                empid: _empdid,
                prospid: _prospid
            },
            prospobsid: 0
        }

        setModel(_model);
        setShow(true);
    }

    useImperativeHandle(ref, () => ({
        openModal,
        closeModal
    }));

    return (
        model &&
        <Modal show={show} onHide={closeModal} centered={false} size='xl'>
            <ConsultaPadrao model={model} columns={columns} scrollHeight='500px' />
        </Modal>
    )
})